/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entityitemsdescription2Inputs */

const id_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan kepemilikan`)
};

const ms_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekod boleh milik`)
};

const da_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejerskabsposter`)
};

const de_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besitzbare Datensätze`)
};

const en_us2_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownable records`)
};

const es_es2_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de propiedad`)
};

const es_mx2_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de propiedad`)
};

const fil_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga talaan na maaaring pag-aari`)
};

const fr_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements de propriété`)
};

const it_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registri di proprietà`)
};

const hu_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulajdonolható rekordok`)
};

const nl_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigendomsrecords`)
};

const no_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eierbare poster`)
};

const pl_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekordy własności`)
};

const pt_br2_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de propriedade`)
};

const pt_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos de propriedade`)
};

const ro_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înregistrări de proprietate`)
};

const fi_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omistettavat tietueet`)
};

const sv_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ägande-poster`)
};

const vi_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ có thể sở hữu`)
};

const tr_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahip olunabilir kayıtlar`)
};

const cs_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnitelné záznamy`)
};

const bg_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи за притежание`)
};

const ru_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи владения`)
};

const uk_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Права власності`)
};

const ar_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات قابلة للامتلاك`)
};

const hi_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वामित्व योग्य रिकॉर्ड`)
};

const th_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกที่สามารถเป็นเจ้าของได้`)
};

const ja_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有可能なレコード`)
};

const zh_cn2_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可拥有权记录`)
};

const zh_hant1_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可擁有權記錄`)
};

const ko_sandboxes_entityitemsdescription2 = /** @type {(inputs: Sandboxes_Entityitemsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소유 가능 레코드`)
};

/**
* | output |
* | --- |
* | "Ownable records" |
*
* @param {Sandboxes_Entityitemsdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entityitemsdescription2 = /** @type {((inputs?: Sandboxes_Entityitemsdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entityitemsdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entityitemsdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_entityitemsdescription2(inputs)
	if (locale === "da") return da_sandboxes_entityitemsdescription2(inputs)
	if (locale === "de") return de_sandboxes_entityitemsdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entityitemsdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entityitemsdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entityitemsdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_entityitemsdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_entityitemsdescription2(inputs)
	if (locale === "it") return it_sandboxes_entityitemsdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_entityitemsdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_entityitemsdescription2(inputs)
	if (locale === "no") return no_sandboxes_entityitemsdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_entityitemsdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entityitemsdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_entityitemsdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_entityitemsdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_entityitemsdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_entityitemsdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_entityitemsdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_entityitemsdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_entityitemsdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_entityitemsdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_entityitemsdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_entityitemsdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_entityitemsdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_entityitemsdescription2(inputs)
	if (locale === "th") return th_sandboxes_entityitemsdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_entityitemsdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entityitemsdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entityitemsdescription2(inputs)
	return ko_sandboxes_entityitemsdescription2(inputs)
});
export { sandboxes_entityitemsdescription2 as "sandboxes.entityItemsDescription" }